import React from 'react'
import { fetchDepartment } from 'api/departments'

export const useProjectsPanel = ({ id }) => {
  const [search, setSearch] = React.useState('')
  const [department, setDepartment] = React.useState('')

  React.useEffect(() => {
    const loadDepartment = async () => {
      const { response } = await fetchDepartment({ id })

      setDepartment(response)
    }

    loadDepartment()
  }, [id])

  return {
    state: {
      search,
      department,
    },
    handlers: { setSearch },
  }
}
